/* =========================================================
  ____    ___    ____   _   __       __                
 |  _ |  / _ \  |  _ \ | | |   \    |   \  ___  __ __  
 |  __| | |_| | |  __/ | | | |) | o | |) |/ -_) \ V /  
 |_|\_\ |_| |_| |_|    |_| |___/    |___/ \___|  \_/  o o o  

========================================================= */

import axios from "axios";
import { API } from "./Define";

export const FetchData = (mothod, url, token, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(API + url, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      method: mothod,
      data: payload,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const FetchURL = (mothod, url, token, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(url, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      method: mothod,
      data: payload,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};

export const PostData = (url, payload = {}) => {
  return new Promise((resolve, reject) => {
    axios(API + url, {
      headers: { "Content-Type": "application/json" },
      method: "post",
      data: payload,
    })
      .then((res) => {
        resolve(res.data);
      })
      .catch(function (error) {
        reject(error);
      });
  });
};
